import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import { EsgDeleteIcon } from "assets";

interface DeleteButtonProps {
    onClick: () => void;
    tooltipTitle?: string;
    size?: "small" | "medium" | "large";
    disabled?: boolean;
    "aria-label"?: string;
    iconColor?: string;
    width?: string;
    height?: string;
}

export const DeleteButton = ({
    onClick,
    tooltipTitle = "Delete",
    size = "small",
    disabled = false,
    "aria-label": ariaLabel = "Delete",
    iconColor = "red",
    width = "35px",
    height = "35px"
}: DeleteButtonProps) => {
    const button = (
        <IconButton
            aria-label={ariaLabel}
            size={size}
            sx={{
                width,
                height,
                color: iconColor,
                "&:hover": {
                    backgroundColor: "rgba(255, 0, 0, 0.04)",
                },
                "&:active": {
                    backgroundColor: "rgba(255, 0, 0, 0.12)",
                },
                "&:disabled": {
                    color: "rgba(0, 0, 0, 0.26)",
                }
            }}
            onClick={onClick}
            disabled={disabled}
        >
            <EsgDeleteIcon color={iconColor} />
        </IconButton>
    );

    // Wrap disabled button in span to avoid Tooltip warning
    const buttonWithTooltip = disabled ? (
        <span>
            {button}
        </span>
    ) : button;

    return (
        <Tooltip arrow placement="top" title={tooltipTitle}>
            {buttonWithTooltip}
        </Tooltip>
    );
}; 